// Общий скрипт видео-слайдеров (germination-video-slider, ugc-video-slider, OR-Main-Videos).
// Подключается каждой из секций — guard, чтобы при нескольких секциях на странице код выполнился один раз.
if (!window.__orVideoSliderInit) {
window.__orVideoSliderInit = true;
document.addEventListener('DOMContentLoaded', function() {
    // Флаг для отслеживания состояния меню
    let menuIsOpen = false;

    // Определяем селекторы для меню
    const MENU_SELECTORS = {
        bodyClass: 'menu_open',
        closeButtons: '.halo-sidebar-close, [data-menu-close-sidebar]',
        menuContainer: '.mobile-nav, .navigation--mobile, .halo-sidebar, .sidebar-menu',
        overlay: '.mobile-menu-overlay, .menu-overlay, .nav-overlay, .background-overlay'
    };

    // Функция для проверки, открыто ли меню
    function checkMenuState() {
        menuIsOpen = document.body.classList.contains(MENU_SELECTORS.bodyClass);
        return menuIsOpen;
    }

    // Обработчик для кнопок закрытия меню (только когда меню открыто)
    function handleMenuCloseClick(e) {
        if ((e.target.closest('.halo-sidebar-close') ||
             e.target.closest('[data-menu-close-sidebar]')) &&
            checkMenuState()) {

            document.body.classList.remove(MENU_SELECTORS.bodyClass);

            document.querySelectorAll(MENU_SELECTORS.menuContainer).forEach(function(menu) {
                menu.classList.remove('active', 'open', 'visible', 'is-open');
                menu.style.display = 'none';
            });

            document.querySelectorAll(MENU_SELECTORS.overlay).forEach(function(overlay) {
                overlay.style.display = 'none';
                overlay.classList.remove('active', 'visible');
            });

            document.body.style.overflow = 'auto';
            document.documentElement.style.overflow = 'auto';

            e.stopPropagation();
            e.preventDefault();

            return false;
        }
    }

    document.addEventListener('click', handleMenuCloseClick, false);

    // ЛЕНТА СЛАЙДОВ: нативный горизонтальный скролл.
    // Slick убран: две секции инициализировали один класс разными конфигами
    // (slidesToShow:6 против variableWidth:true), CSS width:!important ломал его
    // математику, и последний слайд был недостижим. Нативный скролл всегда
    // долистывается до конца и не требует jQuery.
    document.querySelectorAll('.organo-republic-video-slider').forEach(function(root) {
        var container = root.querySelector('.organo-republic-video-slider__container');
        if (!container) return;
        if (container.hasAttribute('data-or-arrows-bound')) return;
        container.setAttribute('data-or-arrows-bound', '1');

        function step() {
            return Math.max(200, Math.round(container.clientWidth * 0.8));
        }
        var prev = root.querySelector('.organo-republic-video-slider__arrow--prev');
        var next = root.querySelector('.organo-republic-video-slider__arrow--next');
        if (prev) prev.addEventListener('click', function(e) {
            e.preventDefault();
            container.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function(e) {
            e.preventDefault();
            container.scrollBy({ left: step(), behavior: 'smooth' });
        });
    });

    // Функция для создания миниатюры из видео
    function createVideoThumbnail(videoUrl, thumbnailElement) {
        var tempVideo = document.createElement('video');
        tempVideo.crossOrigin = 'anonymous';
        tempVideo.preload = 'metadata';
        tempVideo.muted = true;
        tempVideo.playsInline = true;

        var source = document.createElement('source');
        source.src = videoUrl;

        if (videoUrl.toLowerCase().endsWith('.mp4')) {
            source.type = 'video/mp4';
        } else if (videoUrl.toLowerCase().endsWith('.mov')) {
            source.type = 'video/quicktime';
        } else if (videoUrl.toLowerCase().endsWith('.webm')) {
            source.type = 'video/webm';
        }

        tempVideo.appendChild(source);

        tempVideo.addEventListener('loadedmetadata', function() {
            this.currentTime = 0.1;
        });

        tempVideo.addEventListener('seeked', function() {
            var canvas = document.createElement('canvas');
            canvas.width = this.videoWidth || 400;
            canvas.height = this.videoHeight || 300;

        var ctx = canvas.getContext('2d');
            ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

            var dataUrl = canvas.toDataURL('image/jpeg', 0.8);
            thumbnailElement.src = dataUrl;
            thumbnailElement.classList.remove('hidden');
            thumbnailElement.style.display = 'block';

            tempVideo.remove();
            canvas.remove();
        });

        tempVideo.load();
    }

    // Создаем миниатюры для всех видео без обложки
    document.querySelectorAll('.organo-republic-video-slider__video-thumbnail').forEach(function(thumbnail) {
        var videoUrl = thumbnail.getAttribute('data-video-url');
        if (videoUrl) {
            createVideoThumbnail(videoUrl, thumbnail);
        }
    });

    // Модальные окна: каждый контейнер связан со своей модалкой через data-атрибуты
    function initModalForContainer(container) {
        var modalId = container.getAttribute('data-modal-id') || 'videoModal';
        var videoId = container.getAttribute('data-video-id') || 'modalVideo';
        var closeId = container.getAttribute('data-close-id') || 'closeModal';

        var modal = document.getElementById(modalId);
        var modalVideo = document.getElementById(videoId);
        var closeModalBtn = document.getElementById(closeId);

        if (!modal || !modalVideo) return;

        container.querySelectorAll('.organo-republic-video-slider__play-button').forEach(function(btn) {
            btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var slide = this.closest('.organo-republic-video-slider__item');
                if (!slide) return;
                var videoUrl = slide.getAttribute('data-video-url');
                if (!videoUrl) return;

                modalVideo.src = videoUrl;
                modalVideo.currentTime = 0;
                modal.style.display = 'flex';
                document.body.style.overflow = 'hidden';

                setTimeout(function() {
                    var playPromise = modalVideo.play();
                    if (playPromise !== undefined) {
                        playPromise.catch(function(error) {
                            console.log('Автовоспроизведение заблокировано:', error);
                        });
                    }
                }, 300);
            });
        });

        function closeVideoModal() {
            modalVideo.pause();
            modalVideo.src = '';
            modal.style.display = 'none';
            document.body.style.overflow = '';
        }

        if (closeModalBtn) {
            closeModalBtn.addEventListener('click', function(e) {
                e.preventDefault();
                closeVideoModal();
            });
        }

        modal.addEventListener('click', function(e) {
            if (e.target === modal) {
                closeVideoModal();
            }
        });
    }

    document.querySelectorAll('.organo-republic-video-slider__container').forEach(function(container) {
        initModalForContainer(container);
    });

    // Глобальное закрытие по Escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            document.querySelectorAll('.organo-republic-video-modal').forEach(function(modal) {
                if (modal.style.display === 'flex') {
                    var video = modal.querySelector('video');
                    if (video) {
                        video.pause();
                        video.src = '';
                    }
                    modal.style.display = 'none';
                    document.body.style.overflow = '';
                }
            });
        }
    });
});
}
